const getPagedResults = (pageIndex, pageSize, totalResults) => {
  const pageNumber = pageIndex + 1;
  const minResults =
    totalResults <= pageNumber * pageSize && totalResults >= 0
      ? totalResults
      : pageNumber * pageSize;
  return Math.min(minResults, totalResults);
};

export default getPagedResults;
